import { useTheme } from '@emotion/react'

import { BonobosMonoLogo, StylepitMonoLogo, TradesyMonoLogo } from '@segment/matcha/components/CompanyLogos/CompanyMono'

import { BonobosLogo, StylepitLogo, TradesyLogo } from '@segment/matcha/components/CompanyLogos/Company'

const testimonialData = () => {
  const theme = useTheme()
  return [
    {
      company: `bonobos`,
      logo: <BonobosMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <BonobosLogo />,
      logoName: `Bonobos`,
    },
    {
      company: `stylepit`,
      logo: <StylepitMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <StylepitLogo />,
      logoName: `Stylepit`,
    },
    {
      company: `tradesy`,
      logo: <TradesyMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <TradesyLogo />,
      logoName: `Tradesy`,
    },
  ]
}

export { testimonialData }
